<template>
  <div id="nav-bar-search-component" class="red-color pt-1 pb-1 text-white">
    <div class="d-flex text-center item fs-5">
      <div class="clickable item-menu" @click="clickedHome">{{ welcome }}</div>
      <div class="clickable border-start border-2 item-menu" @click="$router.push('/videos')">{{ videos }}</div>
      <div class="clickable border-start border-2 item-menu" @click="$router.push('/agency')">{{ photosAgency }}</div>
      <div class="clickable border-start border-2 item-menu" @click="$router.push('/corporate')">{{ corporate }}</div>
      <div class="clickable border-start border-2 item-menu" @click="$router.push('/contact')">{{ contact }}</div>
      <NavBarSearch class="flex-grow-1 text-center" id="nav-bar-nav-bar-search"/>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";
import { useCategoryStore } from "@/stores/category";

import { TEXT_KEYS, ROUTER_PATH_HOME } from "@/constants";

import NavBarSearch from "@/components/NavBarSearch.vue"

@Options({
  components: {
    NavBarSearch
  }
})
export default class NavBar extends Vue {
  languageStore = useLanguageStore()
  categoryStore = useCategoryStore()

  get welcome() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_WELCOME)
  }

  get videos() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_VIDEOS)
  }

  get photosAgency() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_PHOTOS_AGENCY)
  }

  get corporate() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_CORPORATE)
  }

  get contact() {
    return this.languageStore.text(TEXT_KEYS.NAV_BAR_CONTACT)
  }

  public clickedHome() {
    console.log("clicked home")

    if (this.$router.currentRoute.value.path !== ROUTER_PATH_HOME) {
      this.$router.push({ path: '/', replace: true })
    }
  }
}
</script>

<style lang="stylus">
@media screen and (max-width: 480px) {
  .item {
    font-size: 0.75rem;
  }

  .item-menu {
    width: 23%
  }
}

@media screen and (min-width: 481px) {
  .item {
    font-size: 1.13rem;
  }

  .item-menu {
    width: 13%
  }
}


</style>
